import React from 'react';
import { YFMWrapper } from '../../../../components';
import { block } from '../../../../utils';
import './ConstructorFootnotes.css';
const b = block('constructor-footnotes');
/**
 * @deprecated use Content block instead
 *
 * @return - JSX
 */
export const ConstructorFootnotes = ({ items }) => (React.createElement("ol", { className: b() }, items.map((footnote, index) => (React.createElement("li", { className: b('item'), key: index },
    React.createElement(YFMWrapper, { content: footnote, modifiers: {
            constructor: true,
            constructorFootnotePage: true,
        } }))))));
